import { AppState } from 'src/store'

export const SelectFilter = (state: AppState) => {
    return state.filter.filter.expression;
}

export const SelectDisabled = (state: AppState) => {
    return state.filter.filter.disabled;
}
